import { api } from "@/features/utils/fetch-server";
import { useMutation } from "@tanstack/react-query";

/**
 * The HeyUp team, as a new client reaches it to set up what the wizard does
 * not (their own number, their software).
 *
 * The same line and the same "rappelez-moi" as the landing page
 * (`heyup-landing/src/lib/links.ts` and `src/lib/callback.ts`): the public
 * callback on HeyUp's own web connector, so the call leaves from HeyUp's side
 * and is answered by HeyUp's agent whatever number the client registered as a
 * demo caller.
 */
export const HEYUP_PHONE_E164 = "+33939034487";

/** HeyUp's own web connector, the one the landing page's callback uses. */
const HEYUP_CONNECTOR_ID = "mu181xvfy9dh";

export function useCallHeyUpTeam() {
  return useMutation({
    mutationFn: (phoneNumber: string) =>
      api.post<
        { status?: string },
        { connector: string; phone_number: string }
      >("/api/public/v1/callback", {
        connector: HEYUP_CONNECTOR_ID,
        phone_number: phoneNumber,
      }),
  });
}
